module.exports = __webpack_public_path__ + "media/images/articles/resignation/cover-d7cfdefba8ae7c93c620e631786b0adc.png";